
import { mapGetters } from 'vuex'
import InnerLoading from '~/components/Shared/Loading/InnerLoading.vue'
import ProductCard from '../../Products/ProductCardV2.vue'
export default {
  components: {
    InnerLoading,
    ProductCard,
    ProductCardVerticalImage: () =>
      import('@/components/Products/ProductCardVerticalImage.vue'),
  },
  props: {
    product: {
      default: () => {},
    },
  },
  data() {
    return {
      similarProducts: [],
      loading: true,
      activeIndex: 0,
      swiperOption: {
        slidesPerView: 3,
        spaceBetween: 10,
        loop: false,
        breakpoints: {
          640: {
            slidesPerView: 1,
            spaceBetween: 20,
          },
          768: {
            slidesPerView: 2,
            spaceBetween: 40,
          },
          1024: {
            slidesPerView: 2,
            spaceBetween: 50,
          },
        },
      },
    }
  },
  computed: {
    ...mapGetters({
      getUserIP: 'user/getUserIP',
    }),
    Contents() {
      return this.$store.state.settings.contents
    },
    ProductCardComponent() {
      const productCardComponent = this.Contents.componentSettings.find(
        (c) => c.title === 'ProductCard'
      )
      if (!productCardComponent) return 'ProductCard'
      else return productCardComponent.description
    },
  },
  methods: {
    async GET_SIMILAR_PRODUCTS() {
      this.loading = true
      const response = await this.$api.get(
        `Products/SimilarProduct?productId=${this.product.id}&currency=${this.getUserIP.currency}`
      )
      if (response.message === 'OK') {
        this.similarProducts = response.data
      } else this.similarProducts = []
      this.loading = false
    },
  },
  mounted() {
    this.GET_SIMILAR_PRODUCTS()
  },
}
